import type * as THREE from "three";

const isMaterialWithColor = (material: THREE.Material): material is THREE.MeshStandardMaterial =>
  "color" in material;

export const isMeshWithStandardMaterial = (
  mesh: THREE.Mesh,
): mesh is THREE.Mesh & { material: THREE.MeshStandardMaterial } =>
  !Array.isArray(mesh.material) && isMaterialWithColor(mesh.material);
